import axios from 'axios';
import {
  loginreq,
  reqF,
} from './axiosFun';

export const loginNew = (params) => {
  return loginreq("post", "/api/sysConfig/Login/LoginForWeb", params)
};
export const LoginForValidCodeWeb = (params) => {
  return loginreq("post", "/api/sysConfig/Login/LoginForValidCodeWeb", params)
};
export const CreateValidCode = (params) => {
  return loginreq("post", "/api/sysConfig/Login/CreateValidCode", params)
};

// 修改密码
export const UpdatePassWord = (params) => {
  return reqF("post", "/api/user/User/UpdatePassWord", params)
};
